import { addAmplitudeLogEvent } from "@/mixins/common";
import { amplitudeEventNames } from "@/enums";

const mutations = {
  setNotification: (state, notification) => {
    const hasNotification = state.notifications.some(item => JSON.stringify(item) == JSON.stringify(notification));

    if (hasNotification) return;

    state.notifications.push(notification);

    addAmplitudeLogEvent.methods.addAmplitudeLogEvent(amplitudeEventNames.foundError, {
      error_name: notification.title.replace(/ *\([^)]*\) */g, "  ")
    });

  },
  removeNotifications: (state) => (state.notifications =[]),
  removeNotification: (state,notification) => (state.notifications=state.notifications.filter(notify=>JSON.stringify(notify)!==JSON.stringify(notification))),
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/notifications/mutations.js